module.exports = __webpack_public_path__ + "img/diesel-locomotive-mask-08.d41c7d0b.png";